"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TivSentFailure = exports.LogTivSentResponse = exports.LogTivSentRequest = exports.TivSentFailure_Enum = void 0;
const uuid_1 = require("../../../core/uuid");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Enum indicates the type of failure or failure reason for an unsuccessful TIV broadcast */
var TivSentFailure_Enum;
(function (TivSentFailure_Enum) {
    /** UNSET - Default enum value */
    TivSentFailure_Enum[TivSentFailure_Enum["UNSET"] = 0] = "UNSET";
    /** GENERIC_FAILURE - Enum indicates a generic failure */
    TivSentFailure_Enum[TivSentFailure_Enum["GENERIC_FAILURE"] = 1] = "GENERIC_FAILURE";
    TivSentFailure_Enum[TivSentFailure_Enum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TivSentFailure_Enum = exports.TivSentFailure_Enum || (exports.TivSentFailure_Enum = {}));
function createBaseLogTivSentRequest() {
    return { broadcastId: undefined, communicationChannel: 0, failureReason: 0 };
}
exports.LogTivSentRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.broadcastId !== undefined) {
            uuid_1.UUID.encode(message.broadcastId, writer.uint32(10).fork()).ldelim();
        }
        if (message.communicationChannel !== 0) {
            writer.uint32(16).int32(message.communicationChannel);
        }
        if (message.failureReason !== 0) {
            writer.uint32(24).int32(message.failureReason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogTivSentRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.broadcastId = uuid_1.UUID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.communicationChannel = reader.int32();
                    break;
                case 3:
                    message.failureReason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLogTivSentRequest();
        message.broadcastId =
            object.broadcastId !== undefined && object.broadcastId !== null
                ? uuid_1.UUID.fromPartial(object.broadcastId)
                : undefined;
        message.communicationChannel = object.communicationChannel ?? 0;
        message.failureReason = object.failureReason ?? 0;
        return message;
    },
};
function createBaseLogTivSentResponse() {
    return {};
}
exports.LogTivSentResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogTivSentResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseLogTivSentResponse();
        return message;
    },
};
function createBaseTivSentFailure() {
    return {};
}
exports.TivSentFailure = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTivSentFailure();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseTivSentFailure();
        return message;
    },
};
//# sourceMappingURL=log_tiv_sent.js.map